/**
 * W2 — Backlog de solicitações internas por idade (dias úteis), do bloco
 * Backlog do Painel de Assistências. Só para quem vê o painel.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterPainelAssistencias } from "../../../services/solicitacoes";
import { CardBody, CardFooter, KpiSub, KpiValor, LinkLight } from "../styles";

export const meta = {
  id: "solicitacoes_backlog",
  label: "Backlog de solicitações por idade",
  descricao: "Solicitações internas abertas agora, por faixa de idade em dias úteis.",
  categoria: "Pendencias",
  permissoes: ["solicitacao:painel"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const d = await obterPainelAssistencias(request, { periodo: "30d" });
  const b = d?.backlog || {};
  return { abertas: b.abertas ?? 0, faixas: b.idade_faixas || [] };
}

export function Widget({ dados }) {
  const faixas = dados?.faixas || [];
  const max = Math.max(1, ...faixas.map((f) => f.total));
  return (
    <>
      <CardBody>
        <KpiValor>{dados?.abertas ?? 0}</KpiValor>
        <KpiSub>abertas agora, por idade (d.u.)</KpiSub>
        <div style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 8 }}>
          {faixas.map((f) => (
            <div key={f.faixa} style={{ display: "grid", gridTemplateColumns: "56px 1fr 28px", gap: 6, alignItems: "center", fontSize: 11.5 }}>
              <span style={{ color: "var(--ink-3)" }}>{f.faixa}</span>
              <span style={{ height: 6, borderRadius: 3, background: "var(--surface-2)", overflow: "hidden" }}>
                <span style={{ display: "block", height: "100%", width: `${(100 * f.total) / max}%`, background: "var(--chart-2)" }} />
              </span>
              <span style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{f.total}</span>
            </div>
          ))}
        </div>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/suprimentos/painel-assistencias?aba=backlog">Ver o backlog</LinkLight>
      </CardFooter>
    </>
  );
}
